import { instance, objectToParams } from './api';

export const getCustomersList = (args) => instance.get(`/api/v1/customers?${objectToParams(args)}`);

export const getCustomer = (id) => instance.get(`/api/v1/customers/${id}`);

export const postCustomer = (form) => instance.post(`/api/v1/customers`, form);

export const getCustomerOrders = (id, args) => instance.get(`/api/v1/customers/${id}/orders?${objectToParams(args)}`);

export const putCustomer = (id, form) => instance.put(`/api/v1/customers/${id}`, form);

export const deleteCustomer = (id) => instance.delete(`/api/v1/customers/${id}`);
